// Configuración central de marca (Fase 6.1 + 6.4 — white label).
// La MISMA base levanta como GirosBol (defaults) u otra marca vía REACT_APP_BRAND_ID.
// Resolución:
//   1) REACT_APP_BRAND_ID selecciona un preset (default "girosbol").
//   2) Cualquier REACT_APP_BRAND_* individual pisa el valor del preset.

const PRESETS = {
  girosbol: {
    name: 'GirosBol',
    legalName: 'Vitsil SpA',
    legalRut: '78.002.172-1',
    tagline: 'Transferencias Internacionales',
    domain: 'girosbol.com',
    supportEmail: 'info@girosbol.com',
    complianceEmail: 'cumplimiento@girosbol.com',
    botName: 'Carla',
    whatsapp: '56964299538',
    // Domicilio / oficina (Fase 8.a — sin fallbacks entre marcas).
    legalCity: 'Copiapó, Chile',
    officeAddress: "O'Higgins 443, local 24, Copiapó",
    theme: {
      primary: '#15803D',
      primaryDark: '#065F46',
      accent: '#F59E0B',
      secondary: '#111111',
      background: '#FFFFFF',
      backgroundAlt: '#F5F5F5',
      whatsapp: '#25D366',
    },
    // Claves localStorage LEGACY — no cambiar en instancia con usuarios activos
    storage: {
      splash: 'girosbol_splash_shown',
      client: 'girosbol-client',
      admin: 'girosbol-admin',
    },
    // Feature flags — GirosBol tiene todos los módulos históricos activos.
    features: { wallet: true, gbPuntos: true, credibol: true, sorteo: true, pitchDeck: true, whatsappBot: true, telegramBroadcast: true, empresas: true },
    puntosProgramName: 'GB Puntos',
    minTransferClp: 1000,
    maxTransferClp: 2000000,
    // Contenido de la landing (Fase 6.1) — todo lo que dice "Bolivia" acá.
    landing: {
      // Layout renderer: 'classic' preserva la landing histórica de GirosBol pixel a pixel.
      layout: 'classic',
      origin: { name: 'Chile', code: 'cl' },
      dest: { name: 'Bolivia', code: 'bo' },
      badgeText: 'Empresa boliviano-chilena',
      familiesBadge: '+900 familias conectadas',
      // Colores exactos de la landing histórica (verdes puros, NO derivados del theme).
      heroHighlight: '#4ade80',
      ctaButton: '#008000',
      ctaButtonDark: '#004d00',
      showRetentionPill: true,
      retentionPillText: '96% repite',
      // Estado regulatorio (Fase 7.f). Sólo declaraciones verificables — nunca
      // afirmar "supervisada / autorizada / certificada / avalada" por la UAF.
      regulatoryBadge: {
        enabled: true,
        label: 'Empresa registrada ante la UAF',
        sublabel: 'Unidad de Análisis Financiero · Chile',
        whyUsTitle: 'Empresa registrada ante la UAF',
        whyUsDesc: 'Sujeto obligado conforme a la Ley 19.913 de Chile. Reportamos operaciones sospechosas a la Unidad de Análisis Financiero según la normativa vigente.',
      },
      // Config de la calculadora — layout 'classic' preserva la UI histórica.
      calculator: {
        layout: 'classic',
        origins: [
          { code: 'CLP', name: 'Chile', flagCode: 'CL', symbol: '$' },
          { code: 'BOB', name: 'Bolivia', flagCode: 'BO', symbol: 'Bs' },
        ],
      },
      hero: [
        { title: 'Envia dinero a Bolivia', highlight: 'en minutos', subtitle: 'Rapido, seguro y legal. La mejor tasa desde Chile.' },
        { title: 'Tu apoyo llega', highlight: 'a quienes mas quieres', subtitle: 'Conectamos familias entre Chile y Bolivia cada dia.' },
        { title: 'Tu dinero', highlight: 'siempre protegido', subtitle: 'Sin estafas, sin perdidas. 100% confiable y regulado.' },
      ],
      stats: [
        { value: '+900', label: 'Familias conectadas' },
        { value: '96', suffix: '%', label: 'Repite con nosotros' },
        { value: '5', suffix: ' paises', label: 'Soporte 24/7' },
      ],
      countries: [
        { code: 'bo', name: 'Bolivia', tag: 'Popular' },
        { code: 'ar', name: 'Argentina' },
        { code: 'pe', name: 'Peru' },
        { code: 've', name: 'Venezuela' },
        { code: 'co', name: 'Colombia' },
      ],
      testimonials: [
        { name: 'Rosa M.', city: 'Santiago', text: 'Envio dinero a mi mama en La Paz cada mes. Es rapido y seguro. Lo recomiendo!' },
        { name: 'Diego V.', city: 'Copiapo', text: 'La mejor tasa que he encontrado. Y el soporte por WhatsApp es excelente.' },
        { name: 'Carmen L.', city: 'Concepcion', text: 'Antes usaba gente en la calle. Ahora estoy tranquila. Legal y confiable.' },
      ],
      faqs: [
        { q: 'Cuanto tarda en llegar el dinero?', a: 'En la mayoria de los casos, entre 15 y 60 minutos despues de confirmar tu pago. En horario habil bancario es casi instantaneo. Fines de semana o feriados puede tardar hasta el siguiente dia habil.' },
        { q: 'Que pasa si me equivoco con la cuenta del destinatario?', a: 'Te recomendamos siempre revisar los datos con calma antes de confirmar. Recuerda que si la cuenta que ingresaste pertenece a una persona real, el dinero se depositara ahi y luego no podremos retirarlo. Si te das cuenta de algun detalle equivocado, escribenos al WhatsApp lo mas rapido posible y juntos detenemos el envio antes de que se procese.' },
        { q: 'A que paises puedo enviar?', a: 'Actualmente: Bolivia, Argentina, Peru, Venezuela y Colombia. Desde Chile o desde Bolivia. Pronto sumaremos mas destinos.' },
        { q: 'Necesito tener cuenta bancaria en el pais destino?', a: 'Tu destinatario si necesita una cuenta bancaria local en su pais para recibir el dinero. Tu solo necesitas hacer la transferencia desde Chile o Bolivia y nosotros nos encargamos del resto.' },
        { q: 'Cual es el monto minimo y maximo que puedo enviar?', a: 'El minimo es de $10.000 CLP (o equivalente en BOB). El maximo mensual depende de tu nivel de verificacion KYC: usuarios identificados pueden enviar hasta $5.000.000 CLP al mes. Empresas tienen limites mas altos.' },
      ],
      finalCtaText: 'Registrate gratis en 5 minutos y envia dinero a Bolivia y mas paises en minutos.',
      footerTagline: 'Transferencias internacionales desde Bolivia y Chile al mundo. Una empresa del grupo VitSil.',
      footerServices: [
        { label: 'Envios desde Bolivia', to: '/register' },
        { label: 'Envios desde Chile', to: '/register' },
      ],
      footerWhatsAppDisplay: '+56 9 2861 8528',
      footerWhatsAppNumber: '56928618528',
      // Moneda destino por defecto en la calculadora
      defaultDestCurrency: 'BOB',
    },
    exchange: {
      // Corredor principal GirosBol: CLP ↔ BOB (bidireccional).
      primary: { code: 'BO', currency: 'BOB', name: 'Bolivia', flag: '🇧🇴', flagCode: 'BO', symbol: 'Bs', locale: 'es-BO' },
      // Corredores destino disponibles. GirosBol ofrece los 5 destinos históricos.
      corridors: [
        { code: 'BO', currency: 'BOB', name: 'Bolivia', flag: '🇧🇴', flagCode: 'BO', symbol: 'Bs', active: true },
        { code: 'PE', currency: 'PEN', name: 'Perú', flag: '🇵🇪', flagCode: 'PE', symbol: 'S/', active: true },
        { code: 'AR', currency: 'ARS', name: 'Argentina', flag: '🇦🇷', flagCode: 'AR', symbol: '$', active: true },
        { code: 'CO', currency: 'COP', name: 'Colombia', flag: '🇨🇴', flagCode: 'CO', symbol: '$', active: true },
        { code: 'VE', currency: 'VES', name: 'Venezuela', flag: '🇻🇪', flagCode: 'VE', symbol: 'Bs', active: true },
      ],
      // Orígenes soportados. GirosBol permite enviar desde Chile y desde Bolivia.
      // minTransfer/maxTransfer son la única fuente de límites para calculadoras y validaciones.
      origins: [
        { code: 'CLP', name: 'Chile', flagCode: 'CL', symbol: '$', minTransfer: 1000, maxTransfer: 2000000 },
        { code: 'BOB', name: 'Bolivia', flagCode: 'BO', symbol: 'Bs', minTransfer: 50, maxTransfer: 20000 },
      ],
      // Rangos históricos GirosBol (los usa el panel como valor inicial editable).
      defaultCommissionTiers: [
        { min: 10000, max: 49999, commission: 10 },
        { min: 50000, max: 99999, commission: 7 },
        { min: 100000, max: 499999, commission: 6 },
        { min: 500000, max: 2000000, commission: 4 },
      ],
    },
  },
  enviosclick: {
    name: 'EnviosClick',
    legalName: 'Envíos Click SpA',
    legalRut: 'PLACEHOLDER-RUT',
    tagline: 'Envía dinero fácil, rápido y seguro',
    domain: 'enviosclick.cl',
    supportEmail: 'contacto@enviosclick.cl',
    complianceEmail: 'cumplimiento@enviosclick.cl',
    botName: 'Noheli',
    whatsapp: '56994581743',
    // Domicilio pendiente hasta que Envíos Click SpA lo entregue.
    legalCity: null,
    officeAddress: null,
    theme: {
      // HEX exactos verificados del logo original
      primary: '#9811CF',        // morado dominante
      primaryDark: '#6E0D97',    // pressed / hover
      accent: '#C50ED8',         // magenta brillante (punta del avión)
      secondary: '#111111',      // negro del "Click"
      background: '#FFFFFF',
      backgroundAlt: '#F8F7FB',
      whatsapp: '#25D366',
    },
    // Storage: al ser instancia nueva sin usuarios activos, usamos claves propias
    storage: {
      splash: 'enviosclick_splash_shown',
      client: 'enviosclick-client',
      admin: 'enviosclick-admin',
    },
    // Feature flags — módulos exclusivos de GirosBol OFF en EnviosClick.
    features: { wallet: false, gbPuntos: true, credibol: false, sorteo: false, pitchDeck: false, whatsappBot: false, telegramBroadcast: false, empresas: false },
    puntosProgramName: 'Puntos Click',
    minTransferClp: 5000,
    maxTransferClp: 2000000,
    landing: {
      // Layout renderer split: hero con calculadora, franja de pasos, sección de
      // métodos de pago Perú, tipografía geométrica. Marca de identidad propia
      // para no verse como GirosBol repintado.
      layout: 'split',
      // EnviosClick — remesas Chile → Perú y Chile → Bolivia (ambos corredores
      // son propios y ofrecidos por igual, según enviosclick.cl).
      origin: { name: 'Chile', code: 'cl' },
      dest: { name: 'Perú y Bolivia', code: 'pe' },
      badgeText: 'Envíos a Perú y Bolivia',
      // Cifra real del sitio del cliente: "Más de 2.000 transferencias exitosas realizadas."
      familiesBadge: '+2.000 transferencias exitosas',
      // Colores del hero: derivados del theme morado/magenta.
      // heroHighlight en amber-200 (#FDE68A) para máxima legibilidad sobre morado.
      // El magenta #C50ED8 se descartó por bajo contraste sobre fondo morado.
      heroHighlight: '#FDE68A',
      ctaButton: '#9811CF',
      ctaButtonDark: '#6E0D97',
      showRetentionPill: false,
      retentionPillText: '',
      // Estado regulatorio EnviosClick — mismo marco legal chileno.
      // Sólo declaraciones verificables. NO "supervisada / autorizada / certificada / avalada".
      regulatoryBadge: {
        enabled: true,
        label: 'Empresa registrada ante la UAF',
        sublabel: 'Unidad de Análisis Financiero · Chile',
        whyUsTitle: 'Empresa registrada ante la UAF',
        whyUsDesc: 'Sujeto obligado conforme a la Ley 19.913 de Chile. Reportamos operaciones sospechosas a la Unidad de Análisis Financiero según la normativa vigente.',
      },
      // Tipografía distinta a GirosBol — sans geométrica con títulos de peso alto.
      fontImport: 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800;900&display=swap',
      fontFamily: '"Manrope", ui-sans-serif, system-ui, sans-serif',
      // Franja de pasos bajo el hero (layout split).
      steps: [
        { icon: 'Calculator', title: 'Cotiza', desc: 'Ingresa el monto y ve al instante cuánto recibe tu familia.' },
        { icon: 'Send', title: 'Transfiere', desc: 'Yape, Plin o transferencia bancaria desde Chile. Sin filas.' },
        { icon: 'HeartHandshake', title: 'Tu familia recibe', desc: 'Comprobante directo a tu WhatsApp cuando el dinero llega.' },
      ],
      // Sección "Sobre nosotros" — fotos reales del equipo entregadas por el cliente.
      // Texto tomado del propio sitio enviosclick.cl para no inventar copy.
      about: {
        enabled: true,
        badge: 'Iquique · Chile',
        title: 'De un proyecto familiar a una empresa de confianza 24/7',
        paragraph: 'Envíos Click es una empresa dedicada a transferencias de dinero a Perú y Bolivia. Somos rápidos, seguros y trabajamos 24/7 para que tu dinero llegue sin complicaciones. Atención 100% personalizada por WhatsApp.',
        stats: [
          { value: '+2.000', label: 'Transferencias' },
          { value: '24/7', label: 'Atención' },
          { value: '2', label: 'Corredores propios' },
        ],
        featurePhoto: {
          webp: '/team/team-iquique.webp',
          jpg: '/team/team-iquique.jpg',
          webpSm: '/team/team-iquique-sm.webp',
          jpgSm: '/team/team-iquique-sm.jpg',
          alt: 'Equipo de Envíos Click en Iquique',
          caption: 'Nuestro equipo en Iquique',
        },
        portraitPhotos: [
          {
            webp: '/team/team-heart.webp',
            jpg: '/team/team-heart.jpg',
            webpSm: '/team/team-heart-sm.webp',
            jpgSm: '/team/team-heart-sm.jpg',
            alt: 'Equipo Envíos Click Bolivia',
            caption: 'Con el corazón puesto en Bolivia',
          },
          {
            webp: '/team/team-grass.webp',
            jpg: '/team/team-grass.jpg',
            webpSm: '/team/team-grass-sm.webp',
            jpgSm: '/team/team-grass-sm.jpg',
            alt: 'Tres compañeras del equipo Envíos Click',
            caption: 'Un equipo cercano y peruano-chileno',
          },
        ],
      },
      // Redes sociales para el footer.
      social: {
        instagram: { handle: 'envios.clickk', url: 'https://instagram.com/envios.clickk' },
        facebook: { url: 'https://www.facebook.com/share/1D7cNDuKWq/' },
      },
      // Config de la calculadora — layout 'showcase' es el rediseño Fase 7:
      // título sobrio, destino con bandera+nombre, monto recibido enorme, tasa visible.
      calculator: {
        layout: 'showcase',
        origins: [
          { code: 'CLP', name: 'Chile', flagCode: 'CL', symbol: '$' },
          { code: 'PEN', name: 'Perú', flagCode: 'PE', symbol: 'S/' },
        ],
        // Mensaje de tiempo de entrega bajo la tarjeta. Editable acá para
        // ajustar sin tocar componentes.
        // - `textBefore`: peso normal (dejar '' para mostrar sólo el highlight).
        // - `highlight`: en mayúsculas + negrita.
        deliveryMessage: {
          textBefore: 'Tu dinero llega',
          highlight: 'ALTOKE',
        },
      },
      // Métodos de pago disponibles en Perú (destacable, GirosBol no lo tiene).
      paymentMethods: {
        title: 'Tres formas de que llegue a Perú',
        subtitle: 'Elige el método que mejor le acomode a tu familia.',
        items: [
          {
            code: 'yape',
            name: 'Yape',
            desc: 'Instantáneo con solo el número de celular. Ideal para envíos urgentes.',
            badge: 'Inmediato',
            color: '#8B2A9C',
            logo: '/logos/yape.svg',
          },
          {
            code: 'plin',
            name: 'Plin',
            desc: 'Transferencias móviles sin comisión entre bancos peruanos.',
            badge: 'Inmediato',
            color: '#00B4A0',
            logo: '/logos/plin.svg',
          },
          {
            code: 'bank',
            name: 'Transferencia bancaria',
            desc: 'BCP, Interbank, BBVA, Scotiabank y más. Acreditación en 10–15 minutos.',
            badge: '10–15 min',
            color: '#003C71',
            logo: null,
          },
        ],
      },
      hero: [
        {
          title: 'Envía dinero a Perú y Bolivia',
          highlight: 'ALTOKE',
          highlightAfter: ', en minutos',
          subtitle: 'Rápido, seguro y confiable. Yape, Plin y transferencia bancaria desde Chile.',
          imageMobile: '/team/hero-keychain-sm.webp',
          imageDesktop: '/team/hero-keychain.webp',
          imageFocusY: '35%',
        },
        {
          title: 'Tu apoyo llega',
          highlight: 'a quienes más quieres',
          subtitle: 'Atención personalizada por WhatsApp 24/7, incluso feriados.',
          imageMobile: 'https://customer-assets-eiarnc6j.emergentagent.net/job_remesas-platform/artifacts/tz37es52_WhatsApp%20Image%202026-08-10%20at%202.58.08%20PM.jpeg',
          imageDesktop: 'https://customer-assets-eiarnc6j.emergentagent.net/job_remesas-platform/artifacts/tz37es52_WhatsApp%20Image%202026-08-10%20at%202.58.08%20PM.jpeg',
          imageObjectPosition: 'center center',
        },
      ],
      // Stats reales del cliente. NO inventamos retention ni volumen de familias.
      stats: [
        { value: '+2.000', label: 'Transferencias exitosas' },
        { value: '24', suffix: '/7', label: 'Atención por WhatsApp' },
        { value: '10', suffix: '-15 min', label: 'Transferencia bancaria' },
      ],
      // Perú y Bolivia son ambos "Popular" en el sitio real. Resto queda como
      // destinos disponibles vía la plataforma pero no promocionados en enviosclick.cl.
      countries: [
        { code: 'pe', name: 'Perú', tag: 'Popular' },
        { code: 'bo', name: 'Bolivia', tag: 'Popular' },
        { code: 'ar', name: 'Argentina' },
        { code: 've', name: 'Venezuela' },
        { code: 'co', name: 'Colombia' },
      ],
      // Testimonios: NO inventamos nombres ni ciudades. Vacío → la sección se oculta.
      testimonials: [],
      // FAQs textuales del sitio real enviosclick.cl:
      faqs: [
        {
          q: '¿Qué requisitos debo cumplir para operar con Envíos Click?',
          a: 'Ninguno. Solo contactarnos por WhatsApp y uno de nuestros asesores te atenderá.',
        },
        {
          q: '¿Por qué confiar en Envíos Click?',
          a: 'Somos una empresa seria, transparente y confiable. Te enviamos pantallazos del envío directamente a tu WhatsApp. Disponemos de todos nuestros canales digitales para atender cualquier consulta o descargo.',
        },
        {
          q: '¿Cuál es su horario de trabajo?',
          a: 'Trabajamos los 7 días de la semana, las 24 horas del día, incluyendo feriados.',
        },
        {
          q: '¿Existe un monto mínimo para enviar dinero?',
          a: 'El monto mínimo es de $5.000 CLP.',
        },
        {
          q: '¿El dinero llega directo a la cuenta bancaria en Perú o Bolivia?',
          a: 'Sí. Si eliges transferencia bancaria, el dinero se deposita directamente en la cuenta del destinatario en Perú o Bolivia.',
        },
        {
          q: '¿Qué datos necesito de la persona a la que quiero transferir?',
          a: 'Solo necesitas sus datos bancarios o el número de su Yape o Plin, dependiendo del método de envío que elijas.',
        },
      ],
      finalCtaText: 'Regístrate gratis en 5 minutos y envía dinero a Perú y Bolivia con Yape, Plin o transferencia bancaria.',
      // Copy textual del footer real del sitio.
      footerTagline: 'Envíos Click es una empresa dedicada a transferencias de dinero a Perú y Bolivia. Somos rápidos, seguros y trabajamos 24/7 para que tu dinero llegue sin complicaciones. Atención 100% personalizada por WhatsApp.',
      footerServices: [
        { label: 'Envía dinero a Perú', to: '/register' },
        { label: 'Envía dinero a Bolivia', to: '/register' },
      ],
      // WhatsApp oficial del cliente (enviosclick.cl).
      footerWhatsAppDisplay: '+56 9 9458 1743',
      footerWhatsAppNumber: '56994581743',
      // Moneda destino por defecto en la calculadora
      defaultDestCurrency: 'PEN',
    },
    exchange: {
      // Corredor principal EnviosClick: CLP → PEN (Chile → Perú). Corredor
      // inverso PEN → CLP (Perú → Chile) también ofrecido, con su propia
      // config `pen_reverse` en settings.peru_commission.
      primary: { code: 'PE', currency: 'PEN', name: 'Perú', flag: '🇵🇪', flagCode: 'PE', symbol: 'S/', locale: 'es-PE' },
      // Corredores destino disponibles. Perú activo; resto queda listo para que el
      // cliente los habilite desde el panel si los quiere ofrecer.
      corridors: [
        { code: 'PE', currency: 'PEN', name: 'Perú', flag: '🇵🇪', flagCode: 'PE', symbol: 'S/', active: true },
        { code: 'BO', currency: 'BOB', name: 'Bolivia', flag: '🇧🇴', flagCode: 'BO', symbol: 'Bs', active: false },
        { code: 'AR', currency: 'ARS', name: 'Argentina', flag: '🇦🇷', flagCode: 'AR', symbol: '$', active: false },
        { code: 'CO', currency: 'COP', name: 'Colombia', flag: '🇨🇴', flagCode: 'CO', symbol: '$', active: false },
        { code: 'VE', currency: 'VES', name: 'Venezuela', flag: '🇻🇪', flagCode: 'VE', symbol: 'Bs', active: false },
      ],
      // Orígenes soportados. EnviosClick opera bidireccional: Chile → Perú
      // y Perú → Chile (usa el subdoc `pen_reverse` de settings).
      origins: [
        { code: 'CLP', name: 'Chile', flagCode: 'CL', symbol: '$', minTransfer: 5000, maxTransfer: 2000000 },
        { code: 'PEN', name: 'Perú', flagCode: 'PE', symbol: 'S/', minTransfer: 20, maxTransfer: 5000 },
      ],
      // Sin defaults heredados — el cliente carga sus propios rangos desde el panel.
      defaultCommissionTiers: [],
    },
  },
};

const brandId = (process.env.REACT_APP_BRAND_ID || 'girosbol').toLowerCase();
const preset = PRESETS[brandId] || PRESETS.girosbol;

// Env override helper
const pick = (envKey, fallback) => {
  const v = process.env[envKey];
  return (v && v.trim()) ? v.trim() : fallback;
};

const domain = pick('REACT_APP_BRAND_DOMAIN', preset.domain);

export const BRAND = {
  id: brandId,
  name: pick('REACT_APP_BRAND_NAME', preset.name),
  legalName: pick('REACT_APP_BRAND_LEGAL_NAME', preset.legalName),
  legalRut: pick('REACT_APP_BRAND_LEGAL_RUT', preset.legalRut),
  tagline: pick('REACT_APP_BRAND_TAGLINE', preset.tagline),
  domain,
  website: `www.${domain}`,
  supportEmail: pick('REACT_APP_BRAND_SUPPORT_EMAIL', preset.supportEmail),
  complianceEmail: pick('REACT_APP_BRAND_COMPLIANCE_EMAIL', preset.complianceEmail),
  botName: pick('REACT_APP_BRAND_BOT_NAME', preset.botName),
  whatsapp: pick('REACT_APP_WHATSAPP_NUMBER', preset.whatsapp),
  theme: {
    primary: pick('REACT_APP_BRAND_THEME_PRIMARY', preset.theme.primary),
    primaryDark: pick('REACT_APP_BRAND_THEME_PRIMARY_DARK', preset.theme.primaryDark),
    accent: pick('REACT_APP_BRAND_THEME_ACCENT', preset.theme.accent),
    secondary: pick('REACT_APP_BRAND_THEME_SECONDARY', preset.theme.secondary),
    background: pick('REACT_APP_BRAND_THEME_BACKGROUND', preset.theme.background),
    backgroundAlt: pick('REACT_APP_BRAND_THEME_BACKGROUND_ALT', preset.theme.backgroundAlt),
    whatsapp: pick('REACT_APP_BRAND_THEME_WHATSAPP', preset.theme.whatsapp),
  },
  storage: preset.storage,
  minTransferClp: Number(preset.minTransferClp || 0),
  maxTransferClp: Number(preset.maxTransferClp || 0),
  legalCity: preset.legalCity,
  officeAddress: preset.officeAddress,
  landing: preset.landing,
  exchange: preset.exchange || null,
  // Nombre del programa de puntos. Sin fallback cross-marca: si viene vacío,
  // el elemento simplemente no se renderiza (no imprimir un default).
  puntosProgramName: pick('REACT_APP_BRAND_PUNTOS_NAME', preset.puntosProgramName),
  features: preset.features || { wallet: false, gbPuntos: false, credibol: false, sorteo: false, pitchDeck: false, whatsappBot: false, telegramBroadcast: false, empresas: false },
};

/**
 * Inyecta las variables CSS de la marca en :root, para que componentes
 * puedan referenciarlas con var(--brand-primary), var(--brand-accent), etc.
 * Se llama una vez desde index.js al arrancar la app.
 */
export function applyBrandCssVariables() {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const t = BRAND.theme;
  root.style.setProperty('--brand-primary', t.primary);
  root.style.setProperty('--brand-primary-dark', t.primaryDark);
  root.style.setProperty('--brand-accent', t.accent);
  root.style.setProperty('--brand-secondary', t.secondary);
  root.style.setProperty('--brand-bg', t.background);
  root.style.setProperty('--brand-bg-alt', t.backgroundAlt);
  root.style.setProperty('--brand-whatsapp', t.whatsapp);
  // Marca el body con el brand id — brand-theme.css usa este selector para pintar
  // los verdes GirosBol como morados EnviosClick sin tocar cada componente.
  if (document.body) {
    document.body.setAttribute('data-brand', BRAND.id);
  } else {
    // body todavía no existe (ejecución antes de DOMContentLoaded)
    document.addEventListener('DOMContentLoaded', () => {
      document.body.setAttribute('data-brand', BRAND.id);
    });
  }
  // meta theme-color inicial (DynamicManifest luego lo ajusta por sección)
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', t.primary);
  // Título inicial
  if (document.title && !document.title.includes(BRAND.name)) {
    document.title = `${BRAND.name} · ${BRAND.tagline}`;
  }
}
